import type { TranslationMessages } from '../types';

export const orders_report: TranslationMessages = {
  name: 'Orders Report',
  subtitle: 'Analyze order performance and revenue trends',
  export_report: 'Export Report',
  select_date_range: 'Select Date Range',
  choose_period: 'Choose the period you want to analyze',
  from_date: 'From Date',
  to_date: 'To Date',
  generate_report: 'Generate Report',
  generating_report: 'Generating your report...',
  loading_report: 'Loading report...',
  fetching_data: 'Fetching data for the selected period.',
  failed_to_load: 'Failed to load report',
  try_again_message:
    'Please try again or contact support if the problem persists.',
  try_again: 'Try Again',
  total_revenue: 'Total Revenue',
  days_period: 'day |||| days',
  total_orders: 'Total Orders',
  total_orders_in_period: 'Total orders in period',
  average_daily: 'Average Daily',
  per_day_average: 'Per day average',
  daily_breakdown: 'Daily Breakdown',
  revenue_breakdown_description:
    'Revenue breakdown by day for the selected time period',
  no_orders_found: 'No Orders Found',
  no_orders_message:
    'No orders found for the selected time period. Try adjusting your time range.',
  order: 'order |||| orders',
  revenue_chart: 'Revenue Chart',
  revenue_chart_description:
    'Daily revenue and orders over the selected period',
  revenue: 'Revenue',
  orders: 'Orders',
  quick_select: 'Quick Select',
  preset_yesterday: 'Yesterday',
  preset_today: 'Today',
  preset_this_week: 'This Week',
  preset_this_month: 'This Month',
  preset_current_fiscal_month: 'Current Fiscal Month',
  preset_previous_fiscal_month: 'Previous Fiscal Month',
  preset_last_week: 'Last Week',
  preset_last_month: 'Last Month',
  preset_this_year: 'This Year',
  preset_last_year: 'Last Year',
  preset_custom: 'Custom Range',
  delivered_orders: 'Delivered',
  cancelled_orders: 'Cancelled',
  platform_filter: 'Include Platforms',
  };
